const SET_SELECTED_NAVBAR_ITEM = 'SET_SELECTED_NAVBAR_ITEM'

export default {
  SET_SELECTED_NAVBAR_ITEM,
}
